<template>
    <div class="d-flex flex-column justify-start align-start">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-card-title
                    class="text-justify px-5 py-2 mb-2 truncate-overflow"
                    v-bind="attrs"
                    v-on="on"
                    >{{ data.nombre }}</v-card-title
                >
            </template>
            <span>{{ data.nombre }}</span>
        </v-tooltip>

        <div class="diagnostic-text text-justify font-weigth-regular px-5">
            <p class="text-justify text-body-1" v-html="data.contenido.contenido"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: { type: Object, default: null },
    },
}
</script>

<style>
.diagnostic-text {
    height: 45vh;
    overflow: auto;
}
</style>
